export default function ExportBar({ onXLSX, disabled }) {
  return (
    <div className="adm-export-bar">
      <button className="adm-btn-export" onClick={onXLSX} disabled={disabled}>↓ Export XLSX</button>
    </div>
  );
}